var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.icon,{tag:"component",class:[_vm.$style.icon, _vm.colorClass]})}
var staticRenderFns = []

export { render, staticRenderFns }